import { humanise } from '@/lib/format';

/**
 * What each gym audit action means, in words. An action this build has never
 * seen falls back to its own name, made readable, rather than vanishing.
 */
const LABELS: Readonly<Record<string, string>> = {
  // Before Steado set up every gym, owners signed themselves up.
  GYM_OWNER_SIGN_UP: 'Owner signed up',
  GYM_OWNER_INVITE_ACCEPTED: 'Owner accepted the invite and set a password',
  GYM_OWNER_EMAIL_CONFIRMED: 'Owner confirmed their email',
  GYM_OWNER_SIGN_IN_FAILED: 'A sign-in failed',
  GYM_OWNER_SIGN_IN_PAUSED: 'Sign-in paused after failed tries',
  GYM_OWNER_PASSWORD_RESET_REQUESTED: 'Password reset asked for',
  GYM_OWNER_PASSWORD_RESET: 'Password reset',
  GYM_OWNER_REFRESH_REUSE_DETECTED: 'A reused session was refused',
  GYM_UPDATED: 'Gym details changed',
  GYM_JOIN_CODE_ROTATED: 'Join code changed',
  GYM_JOIN_REQUEST_APPROVED: 'Join request approved',
  GYM_JOIN_REQUEST_DECLINED: 'Join request declined',
  GYM_MEMBER_ASSIGNED: 'A member got a trainer',
  GYM_COACHING_ENDED: 'A member’s coaching ended',
  GYM_STAFF_INVITED: 'Trainer invited',
  GYM_STAFF_INVITE_RESENT: 'Trainer invite sent again',
  GYM_STAFF_INVITE_REVOKED: 'Trainer invite withdrawn',
  GYM_STAFF_REMOVED: 'Trainer removed',
  // From before seats and quotes were retired (2026-10-25); old rows still read.
  GYM_QUOTE_ACCEPTED: 'Quote accepted',
  GYM_SEAT_APPROVED: 'Seat approved',
  // Written by the admin console, so it carries the console's own spelling.
  'gym.ai_limits.update': 'Changed AI limits',
  'gym.create': 'Gym created by Steado, owner invited',
  'gym.owner_invite.resend': 'Owner invite sent again',
  'gym.member_limit.update': 'Changed the member limit',
};

export function gymActivityLabel(action: string): string {
  const known = LABELS[action];
  if (known !== undefined) return known;
  const words = humanise(action.replace(/^GYM_/, '').toLowerCase());
  return words.charAt(0).toUpperCase() + words.slice(1);
}
